module.exports = __webpack_public_path__ + "static/bottom-backgound-890cc18115fdb8f71be44e34f12cc8f0.jpg";